import api from 'api';

export const uploadAMSFiles = (endpoint, body, queryParams) => {
  const urlParams = new URLSearchParams(queryParams);
  const urlParamsStr = urlParams.toString();
  const url = `/${endpoint}${(urlParamsStr === '' ? '' : '?')}${urlParamsStr}`;
  return api.postMultipart(url, body, 'bearer');
};
